import React, { FC, ReactNode } from 'react'

import { styled } from '@linaria/react'
import { FormattedMessage } from 'react-intl'

import { RouterLink } from 'components/designSystem/Link/RouterLink'
import { breakpoints } from 'components/designSystem/shared/breakpoints'
import { appAgreementIndexPath, confidentialityPath } from 'components/paths'
import { mergeAllUrls } from 'functions/mergeAllUrls'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'

/**
 * Отдельно вынесенная логика соглашения и конфиденциальности
 * для отдельной стилизации.
 */
export const AcceptMessage: FC<{
  children: (chunks: ReactNode) => ReactNode
}> = ({ children }) => {
  const { pathname } = useShallowEqualSelector(
    ({
      router: {
        location: { pathname },
      },
      systemReducer: { locale },
    }) => ({ pathname, locale })
  )

  return (
    <FormattedMessage
      id="app.you.accept.agreement_2"
      defaultMessage="Продолжая, ты принимаешь условия{br} {agreement} и {confidentiality}"
      values={{
        agreement: (
          <RouterLink
            to={mergeAllUrls(pathname, appAgreementIndexPath)}
            data-name="footer-agreement-mobile-action"
          >
            <FormattedMessage
              id="boarding.social_media_conditions_agreement"
              defaultMessage="Соглашения"
            />
          </RouterLink>
        ),
        confidentiality: (
          <RouterLink
            to={mergeAllUrls(pathname, confidentialityPath)}
            data-name="footer-confidentiality-mobile-action"
          >
            <FormattedMessage
              id="boarding.confidentiality_2"
              defaultMessage="Конфиденциальности"
            />
          </RouterLink>
        ),
        br: <Br />,
      }}
    >
      {(chunks) => <>{children(chunks)}</>}
    </FormattedMessage>
  )
}

const Br = styled.br`
  @media screen and (min-width: ${breakpoints.mobile}px) {
    display: none;
  }
`
